<template>
  <b-col
    lg="4"
    class="team-member-container justify-content-center"
  >
    <div
      v-lazy-container
      class="team-member-image"
    >
      <img
        :data-src="config.fullApiUrl(img)"
        :alt="'Portrait {{ name }}'"
      />
    </div>
    <div class="team-member-text d-flex flex-column align-content-center">
      <div class="team-member-name">
        {{ name }}
      </div>
      <div class="team-member-role">
        {{ $t('Co-Creator') }}
      </div>
      <div class="team-member-description">
        {{ description }}
      </div>
    </div>
  </b-col>
</template>

<script>
export default {
  components: {},

  props: {
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
  },
}
</script>

<style
  lang="scss"
  scoped
>
@import '../../assets/style/vars';
@import '../../assets/style/utils';

.team-member-container {
  height: 450px;
  margin: 50px 0;
}

.team-member-image {
  height: 40%;

  img {
    height: 100%;
    display: block;
    margin-right: auto;
  }
}

.team-member-text {
  height: 60%;
  margin: 10px 0;
}

.team-member-name {
  text-transform: uppercase;
  font-weight: 800;
  margin: 10px 0px 0px;
}

.team-member-role {
  color: #cbcbcb;
  @include fontSizeLineHeight(15px, 18px);
  font-weight: 400;
  text-transform: uppercase;
  margin: 0px 0px 10px;
}

@media (max-width: map-get($grid-breakpoints, lg)) {
}
</style>
